var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.color,attrs:{"id":"marquee"}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marquee3k"},[_c('span',[_c('span',{},[_vm._v("#BLEACHHAIRPARTY")])])])}]

export { render, staticRenderFns }